import { useRosterFocusStore } from "@/store/rosterFocusStore";

function TdSummaryPerDate({
  day,
  count,
  isError,
  groupLength,
  groupIndex,
}: {
  day: number;
  count: number;
  isError?: boolean;
  groupLength?: number;
  groupIndex?: number;
}) {
  const columnKey = `day${day}`;
  const isHovered = useRosterFocusStore((s) => s.hoveredColumn === columnKey);
  const isSelected = useRosterFocusStore((s) => s.selectedColumn === columnKey);
  const setHoveredFocus = useRosterFocusStore((s) => s.setHoveredFocus);
  const clearHoveredFocus = useRosterFocusStore((s) => s.clearHoveredFocus);
  const setSelectedFocus = useRosterFocusStore((s) => s.setSelectedFocus);
  const clearSelectedFocus = useRosterFocusStore((s) => s.clearSelectedFocus);
  const selectedColumn = useRosterFocusStore((s) => s.selectedColumn);
  const selectedNurseId = useRosterFocusStore((s) => s.selectedNurseId);

  const isGrouped = groupLength && groupLength > 1 && groupIndex !== undefined;
  const isFirst = isGrouped && groupIndex === 0;
  const shouldShowBar = isError && (isGrouped ? isFirst : true);

  const highlightBg = isSelected
    ? "rgba(169, 223, 254, 0.4)"
    : isHovered
      ? "rgba(169, 223, 254, 0.3)"
      : undefined;

  return (
    <div
      className="tfootCell relative w-[34px] shrink-0"
      data-column={columnKey}
      style={highlightBg != null ? { backgroundColor: highlightBg } : undefined}
    >
      {/* 위반 시각적 표시 - 단일일 때는 1개 셀 높이, 그룹일 때는 그룹 길이만큼 높이 */}
      {shouldShowBar && (
        <>
          <div
            className="absolute left-1/2 -translate-x-1/2 w-7 z-5 bg-red-500/30 border-red-500/90 border-3 rounded-sm animate-in fade-in duration-300"
            style={{
              willChange: "opacity, transform",
              top: "4px",
              bottom: "4px",
              height: isGrouped
                ? `calc(${groupLength} * 100% + ${(groupLength - 1) * 1}px - 8px)`
                : "calc(100% - 8px)",
            }}
          />
        </>
      )}
      <div className="relative">
        <div className="size-[34px] text-sm relative flex items-center justify-center">
          <div
            className="aspect-square font-[15px] rounded-sm size-7 flex items-center justify-center text-muted-foreground/80"
            onMouseEnter={() => {
              setHoveredFocus({ column: columnKey, nurseId: "" });
            }}
            onMouseLeave={() => {
              clearHoveredFocus();
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (selectedColumn === columnKey && selectedNurseId === "") {
                clearSelectedFocus();
              } else {
                setSelectedFocus({ column: columnKey, nurseId: "" });
              }
            }}
          >
            {count && count > 0 ? count : "·"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TdSummaryPerDate;
